import Dashboard from '../pages/Dashboard';
import Users from '../pages/Users';
import OnboardingUsers from '../pages/OnboardingUsers';
import UserProfile from '../pages/UserProfile';
import AudienceBuilder from '../pages/AudienceBuilder';
import SavedSegments from '../pages/SavedSegments';
import MessageComposer from '../pages/MessageComposer';
import CampaignManager from '../pages/CampaignManager';
import TrustedCircles from '../pages/TrustedCircles';
import TrustedCircleDetail from '../pages/TrustedCircleDetail';
import Organizations from '../pages/Organizations';
import OrganizationDetail from '../pages/OrganizationDetail';
// import Reports from '../pages/Reports';
// import AuditLog from '../pages/AuditLog';
import Settings from '../pages/Settings';
import RefundManagement from '../pages/RefundManagement';
import PaymentAnalytics from '../pages/PaymentAnalytics';
import AlertTemplateList from '../features/alert-templates/AlertTemplateList';
import AlertTemplateEditor from '../features/alert-templates/AlertTemplateEditor';
import LiveAlertMonitor from '../pages/LiveAlertMonitor';
import AlertHistory from '../pages/AlertHistory';
import AlertDetail from '../pages/AlertDetail';
import AlertAnalytics from '../pages/AlertAnalytics';
import PlanTierList from '../features/subscription-plans/PlanTierList';
import PlanTierEditor from '../features/subscription-plans/PlanTierEditor';
import PlanAddonList from '../features/subscription-plans/PlanAddonList';
import PlanAddonEditor from '../features/subscription-plans/PlanAddonEditor';
import SubscriptionList from '../pages/SubscriptionList';
import SubscriptionDetail from '../pages/SubscriptionDetail';
import SponsorPricingList from '../features/sponsor-pricing/SponsorPricingList';
import SponsorPricingEditor from '../features/sponsor-pricing/SponsorPricingEditor';
// import EnterpriseSetupWizard from '../features/enterprise-setup/EnterpriseSetupWizard';
import BrightPatternTemplateList from '../features/bright-pattern-templates/BrightPatternTemplateList';
import BrightPatternTemplateEditor from '../features/bright-pattern-templates/BrightPatternTemplateEditor';
import XmitDirectory from '../pages/XmitDirectory';

/**
 * Sidebar navigation groups. Single source of truth for admin menu.
 * badgeKey: resolved at runtime via useNavBadges (see hooks/useNavBadges.js)
 * dropdown: true  → rendered as a collapsible accordion section (no group label shown)
 */
export const ADMIN_NAV_GROUPS = [
  {
    group: 'Main',
    items: [
      { id: 'dashboard', icon: 'fa-gauge-high', label: 'Dashboard', path: '/dashboard' },
    ],
  },
  {
    group: 'Users Management',
    dropdown: true,
    icon: 'fa-users',
    badgeKey: 'users',
    items: [
      {
        id: 'users-active',
        icon: 'fa-user-check',
        label: 'Active Users',
        path: '/users',
        matchPrefix: true,
        excludePaths: ['/users/onboarding'],
      },
      {
        id: 'users-onboarding',
        icon: 'fa-hourglass-half',
        label: 'Onboarding Progress',
        path: '/users/onboarding',
      },
      {
        id: 'xmit-directory',
        icon: 'fa-tower-broadcast',
        label: 'XMIT Directory',
        path: '/xmit',
      },
    ],
  },
  {
    group: 'Audience Management',
    dropdown: true,
    icon: 'fa-bullseye',
    hidden: true,
    items: [
      { id: 'audience-builder', icon: 'fa-sliders', label: 'Audience Builder', path: '/audience-builder' },
      { id: 'saved-segments', icon: 'fa-bookmark', label: 'Saved Segments', path: '/saved-segments' },
      { id: 'campaign-manager', icon: 'fa-comment-dots', label: 'Campaign Manager', path: '/campaign-manager', badgeKey: 'campaigns' },
      { id: 'message-composer', icon: 'fa-pen-nib', label: 'Message Composer', path: '/message-composer' },
    ],
  },
  {
    group: 'Alerts Management',
    dropdown: true,
    icon: 'fa-bell',
    items: [
      { id: 'alert-templates', icon: 'fa-palette', label: 'Alert Templates', path: '/alert-templates', matchPrefix: true },
      { id: 'bright-pattern-templates', icon: 'fa-headset', label: 'Bright Pattern Templates', path: '/bright-pattern-templates', matchPrefix: true },
      { id: 'live-monitor', icon: 'fa-tower-broadcast', label: 'Live Monitor', path: '/alerts/live' },
      { id: 'alert-history', icon: 'fa-clock-rotate-left', label: 'Alert History', path: '/alerts/history', matchPrefix: true },
      // { id: 'alert-analytics', icon: 'fa-chart-line', label: 'Alert Analytics', path: '/alerts/analytics' },
    ],
  },
  {
    group: 'Payment Management',
    dropdown: true,
    icon: 'fa-credit-card',
    items: [
      { id: 'user-subscriptions', icon: 'fa-user-tag', label: 'User Subscription', path: '/subscriptions', matchPrefix: true },
      { id: 'subscription-plans', icon: 'fa-layer-group', label: 'Subscription Plans', path: '/plans', matchPrefix: true },
      { id: 'plan-addons', icon: 'fa-puzzle-piece', label: 'Plan Add-ons', path: '/plan-addons', matchPrefix: true },
      { id: 'sponsor-pricing', icon: 'fa-tags', label: 'Sponsor Pricing', path: '/sponsor-pricing', matchPrefix: true },
      // { id: 'refunds', icon: 'fa-hand-holding-dollar', label: 'Refund Requests', path: '/refunds' },
      // { id: 'payment-analytics', icon: 'fa-chart-pie', label: 'Payment Analytics', path: '/payment-analytics' },
    ],
  },
  {
    group: 'Management',
    items: [
      { id: 'trusted-circles', icon: 'fa-circle-nodes', label: 'Trusted Circles', path: '/trusted-circles', matchPrefix: true },
      { id: 'organizations', icon: 'fa-building', label: 'Organizations', path: '/organizations', matchPrefix: true },
      // { id: 'enterprise-setup', icon: 'fa-sitemap', label: 'Enterprise Setup', path: '/enterprise-setup' },
      // { id: 'reports', icon: 'fa-chart-bar', label: 'Reports', path: '/reports' },
      // { id: 'audit-log', icon: 'fa-file-lines', label: 'Audit Log', path: '/audit-log' },
    ],
  },
  {
    group: 'System',
    hidden: true,
    items: [
      { id: 'settings', icon: 'fa-gear', label: 'Settings', path: '/settings' },
    ],
  },
];

/** All protected admin routes (sidebar + detail pages). */
export const ADMIN_ROUTES = [
  { path: '/dashboard', Component: Dashboard },
  { path: '/users', Component: Users },
  { path: '/users/onboarding', Component: OnboardingUsers, sidebarPath: '/users/onboarding' },
  { path: '/xmit', Component: XmitDirectory },
  { path: '/users/:userId', Component: UserProfile, sidebarPath: '/users' },
  { path: '/audience-builder', Component: AudienceBuilder },
  { path: '/saved-segments', Component: SavedSegments },
  { path: '/message-composer', Component: MessageComposer },
  { path: '/alert-templates', Component: AlertTemplateList },
  { path: '/alert-templates/new/edit', Component: AlertTemplateEditor, sidebarPath: '/alert-templates' },
  { path: '/alert-templates/:templateId/edit', Component: AlertTemplateEditor, sidebarPath: '/alert-templates' },
  { path: '/bright-pattern-templates', Component: BrightPatternTemplateList },
  { path: '/bright-pattern-templates/:templateId/edit', Component: BrightPatternTemplateEditor, sidebarPath: '/bright-pattern-templates' },
  { path: '/campaign-manager', Component: CampaignManager },
  { path: '/trusted-circles', Component: TrustedCircles },
  { path: '/trusted-circles/:circleId', Component: TrustedCircleDetail, sidebarPath: '/trusted-circles' },
  { path: '/organizations', Component: Organizations },
  { path: '/organizations/:orgId', Component: OrganizationDetail, sidebarPath: '/organizations' },
  // { path: '/enterprise-setup', Component: EnterpriseSetupWizard },
  // { path: '/reports', Component: Reports },
  // { path: '/audit-log', Component: AuditLog },
  { path: '/settings', Component: Settings },
  { path: '/refunds', Component: RefundManagement },
  { path: '/payment-analytics', Component: PaymentAnalytics },
  { path: '/plans', Component: PlanTierList },
  { path: '/plans/:tierId/edit', Component: PlanTierEditor, sidebarPath: '/plans' },
  { path: '/plan-tiers', Component: PlanTierList },
  { path: '/plan-tiers/:tierId/edit', Component: PlanTierEditor, sidebarPath: '/plans' },
  { path: '/plan-addons', Component: PlanAddonList },
  { path: '/plan-addons/new/edit', Component: PlanAddonEditor, sidebarPath: '/plan-addons' },
  { path: '/plan-addons/:addonId/edit', Component: PlanAddonEditor, sidebarPath: '/plan-addons' },
  { path: '/subscriptions', Component: SubscriptionList },
  { path: '/subscriptions/:subscriptionId', Component: SubscriptionDetail, sidebarPath: '/subscriptions' },
  { path: '/sponsor-pricing', Component: SponsorPricingList },
  { path: '/sponsor-pricing/:tierId/edit', Component: SponsorPricingEditor, sidebarPath: '/sponsor-pricing' },
  { path: '/alerts/live', Component: LiveAlertMonitor },
  { path: '/alerts/history', Component: AlertHistory },
  { path: '/alerts/:alertId', Component: AlertDetail, sidebarPath: '/alerts/history' },
  { path: '/alerts/analytics', Component: AlertAnalytics },
];

export function isNavItemActive(pathname, item) {
  const base = item.path;
  if (item.matchPrefix) {
    const excluded = (item.excludePaths || []).some(
      (p) => pathname === p || pathname.startsWith(`${p}/`)
    );
    if (excluded) return false;
    return pathname === base || pathname.startsWith(`${base}/`);
  }
  return pathname === base;
}

/** Returns true if any child of a dropdown group is active */
export function isGroupActive(pathname, group) {
  return group.items.some((item) => isNavItemActive(pathname, item));
}

export function formatNavBadge(count) {
  if (count == null || count <= 0) return null;
  if (count >= 1000) {
    const k = count / 1000;
    return `${k % 1 === 0 ? k.toFixed(0) : k.toFixed(1)}k`;
  }
  return String(count);
}